import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "NewsletterUnsubscribe" })
export default class NewsletterUnsubscribe extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public newsletterUnsubscribeSubmit: any = {};
    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly recaptchaSiteKey: string;

    public mounted() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js");
        document.head.appendChild(recaptchaScript);
    }

    public async setNewsletterUnsubscribeSubmit() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.Newsletter_NewsletterUnsubscribe, this.newsletterUnsubscribeSubmit, { headers: { "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } });

            this.isSuccess = true;
        } catch (error) {

            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }

            (<any>window).grecaptcha.reset();
        }

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};